"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/rules-of-hooks */
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const Axis_1 = require("../../components/Axis");
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const Footnotes_1 = require("../../components/Footnotes");
const Legend_1 = __importDefault(require("../../components/Legend"));
const Sources_1 = require("../../components/Sources");
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const date_1 = require("../../utilities/date");
const types_1 = require("../../utilities/types");
const constants_2 = require("./constants");
const helpers_1 = require("./helpers");
const innerContent_1 = __importDefault(require("./innerContent"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const useLineChartAxis_1 = require("./useLineChartAxis");
const useTooltips_1 = __importDefault(require("./useTooltips"));
const LineChart = _ref => {
  var _Object$values, _Object$values2, _Object$values3, _Object$values4, _Object$values5, _Object$values6, _Object$values7, _Object$values8, _Object$values9, _xAxisOptions$ticks, _yAxisOptions$ticks, _xScale$ticks, _xScale$range, _yScale$ticks, _yScale$range;
  let {
    data: rawData,
    dataSeriesOptions: rawDataSeriesOptions = [],
    fillToOrigin: rawFillToOrigin = constants_2.DEFAULT_FILL_TO_ORIGIN,
    footerOptions = constants_2.DEFAULT_FOOTER_OPTIONS,
    gridLineOptions = constants_2.DEFAULT_GRIDLINE_OPTIONS,
    height = constants_2.DEFAULT_HEIGHT,
    isSpark = constants_2.DEFAULT_IS_SPARK,
    labelOptions = constants_2.DEFAULT_LABEL_OPTIONS,
    legendOptions = constants_2.DEFAULT_LEGEND_OPTIONS,
    onMouseOver: onMouseOverLine,
    onMouseOut: onMouseOutLine,
    onClick: onClickLine,
    selectedLineId: rawSelectedLine = '',
    subtitleOptions = constants_2.DEFAULT_SUBTITLE_OPTIONS,
    titleOptions = constants_2.DEFAULT_TITLE_OPTIONS,
    tooltipOptions = constants_2.DEFAULT_TOOLTIP_OPTIONS,
    width,
    xAxisOptions = constants_2.DEFAULT_XAXIS_OPTIONS,
    yAxisOptions = constants_2.DEFAULT_YAXIS_OPTIONS
  } = _ref;
  if (!rawData || !rawData.length) {
    return null;
  }
  /* Initialize options */
  /* eslint-disable react-hooks/exhaustive-deps */
  const footerOptionsValues = (_Object$values = Object.values(footerOptions)) === null || _Object$values === void 0 ? void 0 : _Object$values.join();
  let optsFooter = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, footerOptions, constants_2.DEFAULT_FOOTER_OPTIONS), [footerOptionsValues]);
  const gridLineOptionsValues = (_Object$values2 = Object.values(gridLineOptions)) === null || _Object$values2 === void 0 ? void 0 : _Object$values2.join();
  let optsGridLine = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, gridLineOptions, constants_2.DEFAULT_GRIDLINE_OPTIONS), [gridLineOptionsValues]);
  const labelOptionsValues = (_Object$values3 = Object.values(labelOptions)) === null || _Object$values3 === void 0 ? void 0 : _Object$values3.join();
  let optsLabel = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, labelOptions, constants_2.DEFAULT_LABEL_OPTIONS), [labelOptionsValues]);
  const legendOptionsValues = (_Object$values4 = Object.values(legendOptions)) === null || _Object$values4 === void 0 ? void 0 : _Object$values4.join();
  let optsLegend = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, legendOptions, constants_2.DEFAULT_LEGEND_OPTIONS), [legendOptionsValues]);
  const subtitleOptionsValues = (_Object$values5 = Object.values(subtitleOptions)) === null || _Object$values5 === void 0 ? void 0 : _Object$values5.join();
  let optsSubtitle = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, subtitleOptions, constants_2.DEFAULT_SUBTITLE_OPTIONS), [subtitleOptionsValues]);
  const titleOptionsValues = (_Object$values6 = Object.values(titleOptions)) === null || _Object$values6 === void 0 ? void 0 : _Object$values6.join();
  let optsTitle = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, titleOptions, constants_2.DEFAULT_TITLE_OPTIONS), [titleOptionsValues]);
  const tooltipOptionsValues = (_Object$values7 = Object.values(tooltipOptions)) === null || _Object$values7 === void 0 ? void 0 : _Object$values7.join();
  let optsTooltip = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, tooltipOptions, constants_2.DEFAULT_TOOLTIP_OPTIONS), [tooltipOptionsValues]);
  const xAxisOptionsValues = (_Object$values8 = Object.values(xAxisOptions)) === null || _Object$values8 === void 0 ? void 0 : _Object$values8.join();
  let optsXAxis = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, xAxisOptions, constants_2.DEFAULT_XAXIS_OPTIONS), [xAxisOptionsValues]);
  const yAxisOptionsValues = (_Object$values9 = Object.values(yAxisOptions)) === null || _Object$values9 === void 0 ? void 0 : _Object$values9.join();
  let optsYAxis = (0, react_1.useMemo)(() => lodash_1.default.defaultsDeep({}, yAxisOptions, constants_2.DEFAULT_YAXIS_OPTIONS), [yAxisOptionsValues]);
  /* eslint-enable react-hooks/exhaustive-deps */
  let fillToOrigin = rawFillToOrigin;
  if (isSpark) {
    optsFooter = {
      ...optsFooter,
      ...constants_2.SPARK_OPTIONS.footerOptions
    };
    optsGridLine = {
      ...optsGridLine,
      ...constants_2.SPARK_OPTIONS.gridLineOptions
    };
    optsLabel = {
      ...optsLabel,
      ...constants_2.SPARK_OPTIONS.labelOptions
    };
    optsLegend = {
      ...optsLegend,
      ...constants_2.SPARK_OPTIONS.legendOptions
    };
    optsSubtitle = {
      ...optsSubtitle,
      ...constants_2.SPARK_OPTIONS.subtitleOptions
    };
    optsTitle = {
      ...optsTitle,
      ...constants_2.SPARK_OPTIONS.titleOptions
    };
    optsTooltip = {
      ...optsTooltip,
      ...constants_2.SPARK_OPTIONS.tooltipOptions
    };
    optsXAxis = {
      ...optsXAxis,
      ...constants_2.SPARK_OPTIONS.xAxisOptions
    };
    optsYAxis = {
      ...optsYAxis,
      ...constants_2.SPARK_OPTIONS.yAxisOptions
    };
    fillToOrigin = false;
  }
  // override to fix empty displayTicks
  if (lodash_1.default.get(xAxisOptions, 'displayTicks.length', -1) === 0) {
    optsXAxis.displayTicks = [];
  }
  if (lodash_1.default.get(yAxisOptions, 'displayTicks.length', -1) === 0) {
    optsYAxis.displayTicks = [];
  }
  const showLegend = optsLegend.show;
  const lineChartWidth = (0, react_1.useMemo)(() => width === 'auto' || !width ? undefined : parseInt(width, 10), [width]);
  const lineChartHeight = (0, react_1.useMemo)(() => height === 'auto' ? '100%' : parseInt(height, 10), [height]);
  // Prepare Data Sets
  const rawDataIds = (0, utilities_1.getDataIds)(rawData);
  const rawDataSeriesOptionsIds = (0, utilities_1.getDataIds)(rawDataSeriesOptions);
  const {
    data,
    dataSeriesOptions
  } = (0, react_1.useMemo)(() => {
    const datasets = (0, utilities_1.extractDatasets)(rawData);
    const dataSeriesOptions = (0, utilities_1.prepareDataSeriesOptions)(datasets, rawDataSeriesOptions).map(dso => ({
      ...dso,
      ...(isSpark ? constants_2.SPARK_OPTIONS.dataSeriesOptions : {})
    }));
    const data = (0, utilities_1.parseData)(datasets, dataSeriesOptions, ['name', 'x_type', 'y_type', 'sources', 'meta']).map(d => ({
      ...d,
      sources: d.sources || [],
      meta: d.meta || [],
      data: d.data.map(_ref2 => {
        let {
          key,
          value
        } = _ref2;
        return {
          key,
          formatted: (0, date_1.dateParser)(key, d.x_type),
          value
        };
      })
    }));
    return {
      data,
      dataSeriesOptions
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawDataIds, rawDataSeriesOptionsIds, isSpark]);
  // Prepare X/Y Data
  const keys = (0, utilities_1.extractKeys)(data, date_1.dateParser);
  const keyValuePairs = data.flatMap(_ref3 => {
    let {
      data
    } = _ref3;
    return data;
  }).map(_ref4 => {
    let {
      key,
      formatted,
      value
    } = _ref4;
    return {
      key,
      formatted,
      value
    };
  });
  const dataIdsString = (0, utilities_1.getDataIds)(data);
  const xType = (0, react_1.useMemo)(() => (0, utilities_1.isValidAxisType)(optsXAxis.type) ? optsXAxis.type : (0, utilities_1.getAxisTypeFromData)(data, 'x') || constants_2.DEFAULT_X_TYPE,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString, optsXAxis.type]);
  const yType = (0, react_1.useMemo)(() => (0, utilities_1.isValidAxisType)(optsYAxis.type) ? optsYAxis.type : (0, utilities_1.getAxisTypeFromData)(data, 'y') || constants_2.DEFAULT_Y_TYPE,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString, optsYAxis.type]);
  const lineMinimums = dataSeriesOptions.map(_ref5 => {
    let {
      displayRangeMin,
      id: lineID
    } = _ref5;
    return displayRangeMin ? [displayRangeMin] : data.find(_ref6 => {
      let {
        id
      } = _ref6;
      return id === lineID;
    }).data.map(_ref7 => {
      let {
        key
      } = _ref7;
      return key;
    }) || [];
  }).flat();
  const lineMaximums = dataSeriesOptions.map(_ref8 => {
    let {
      displayRangeMax,
      id: lineID
    } = _ref8;
    return displayRangeMax ? [displayRangeMax] : data.find(_ref9 => {
      let {
        id
      } = _ref9;
      return id === lineID;
    }).data.map(_ref10 => {
      let {
        key
      } = _ref10;
      return key;
    }) || [];
  }).flat();
  const customLowerXBound = lineMinimums.length > 0 ? (0, date_1.isDateType)(xType) ? lineMinimums.reduce((a, b) => (0, date_1.dateParser)(a, xType) < (0, date_1.dateParser)(b, xType) ? a : b) : Math.min(...lineMinimums) : undefined;
  const customUpperXBound = lineMaximums.length > 0 ? (0, date_1.isDateType)(xType) ? lineMaximums.reduce((a, b) => (0, date_1.dateParser)(a, xType) > (0, date_1.dateParser)(b, xType) ? a : b) : Math.max(...lineMaximums) : undefined;
  const refittedXdomain = (0, react_1.useMemo)(() => [xAxisOptions.displayRangeMin || customLowerXBound, xAxisOptions.displayRangeMax || customUpperXBound], [customLowerXBound, customUpperXBound, xAxisOptions.displayRangeMax, xAxisOptions.displayRangeMin]);
  const pairValuesString = keyValuePairs.map(_ref11 => {
    let {
      values
    } = _ref11;
    return values;
  }).join();
  const keysString = keys.map(_ref12 => {
    let {
      key
    } = _ref12;
    return key;
  }).join();
  const xDomainString = refittedXdomain.join();
  const xTicksString = (_xAxisOptions$ticks = xAxisOptions.ticks) === null || _xAxisOptions$ticks === void 0 ? void 0 : _xAxisOptions$ticks.join();
  const {
    ticks: xTicks,
    scale: xScale,
    values
  } = (0, react_1.useMemo)(() => (0, useLineChartAxis_1.useLineChartXAxis)({
    type: xType,
    keys,
    values: keyValuePairs,
    customDomain: refittedXdomain,
    customTicks: xAxisOptions.ticks
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [pairValuesString, keysString, xDomainString, xTicksString, xType]);
  const valuesString = values.join();
  const yTicksString = (_yAxisOptions$ticks = yAxisOptions.ticks) === null || _yAxisOptions$ticks === void 0 ? void 0 : _yAxisOptions$ticks.join();
  const {
    ticks: yTicks,
    scale: yScale
  } = (0, react_1.useMemo)(() => (0, useLineChartAxis_1.useLineChartYAxis)({
    type: yType,
    values,
    customDomain: [yAxisOptions.displayRangeMin, yAxisOptions.displayRangeMax],
    customTicks: yAxisOptions.ticks
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [valuesString, yAxisOptions.displayRangeMax, yAxisOptions.displayRangeMin, yTicksString, yType]);
  // Line Setup
  let selectedLineId = rawSelectedLine;
  if (dataSeriesOptions.findIndex(_ref13 => {
    let {
      id
    } = _ref13;
    return id === rawSelectedLine;
  }) === -1) {
    selectedLineId = '';
  }
  const [selectedLines, setSelectedLines] = (0, react_1.useState)(selectedLineId.length ? [selectedLineId] : []);
  (0, react_1.useEffect)(() => {
    if (selectedLineId.length) {
      setSelectedLines([selectedLineId]);
    }
    setSelectedLines([]);
  }, [selectedLineId]);
  const [hoveredLabel, setHoveredLabel] = (0, react_1.useState)();
  const dataSeriesOptionsIdsString = (0, utilities_1.getDataIds)(dataSeriesOptions);
  const selectedLinesIdsString = selectedLines.join();
  const setLine = (0, react_1.useCallback)((event, i) => {
    if (!isSpark) {
      const m = dataSeriesOptions[i];
      if (selectedLines.includes(m.id)) {
        setSelectedLines([]);
      } else {
        setSelectedLines([m.id]);
      }
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataSeriesOptionsIdsString, selectedLinesIdsString, isSpark]);
  const [lastTouchPoint, setlastTouchPoint] = (0, react_1.useState)();
  const [scrubStartPoint, setScrubStartPoint] = (0, react_1.useState)();
  (0, react_1.useMemo)(() => {
    if (selectedLines && selectedLines.length && (dataSeriesOptions.length < 2 || !dataSeriesOptions.map(_ref14 => {
      let {
        id
      } = _ref14;
      return id;
    }).includes(selectedLines[0]))) {
      setSelectedLines([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSeriesOptionsIdsString, selectedLinesIdsString]);
  const xScaleTicks = xScale === null || xScale === void 0 ? void 0 : (_xScale$ticks = xScale.ticks) === null || _xScale$ticks === void 0 ? void 0 : _xScale$ticks.call(xScale).join();
  const xScaleRange = xScale === null || xScale === void 0 ? void 0 : (_xScale$range = xScale.range) === null || _xScale$range === void 0 ? void 0 : _xScale$range.call(xScale).join();
  const yScaleTicks = yScale === null || yScale === void 0 ? void 0 : (_yScale$ticks = yScale.ticks) === null || _yScale$ticks === void 0 ? void 0 : _yScale$ticks.call(yScale).join();
  const yScaleRange = yScale === null || yScale === void 0 ? void 0 : (_yScale$range = yScale.range) === null || _yScale$range === void 0 ? void 0 : _yScale$range.call(yScale).join();
  const lineData = (0, react_1.useMemo)(() => {
    const lineDefaults = {
      endMarker: constants_2.DEFAULT_LINE_END_MARKER,
      fontSize: optsLabel.fontSize,
      lineStyle: constants_2.DEFAULT_LINE_STYLE,
      lineWeight: constants_1.DEFAULT_LINE_WEIGHT
    };
    return data.map((0, helpers_1.lineDataMapper)(dataSeriesOptions, xScale.domain(), lineDefaults)).filter(_ref15 => {
      let {
        data
      } = _ref15;
      return data.length;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIdsString, dataSeriesOptionsIdsString, optsLabel.fontSize, xScaleTicks, xScaleRange]);
  if (lineData.length === 0) {
    return null;
  }
  const lineDataIdsString = (0, utilities_1.getDataIds)(lineData);
  const annotationData = (0, react_1.useMemo)(() => dataSeriesOptions.map(function () {
    let {
      id,
      lineWeight,
      annotations = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      color: lineColor,
      fontSize: lineFontSize,
      data = []
    } = lineData.find(_ref16 => {
      let {
        id: dataID
      } = _ref16;
      return dataID === id;
    }) || {};
    return annotations.map(function () {
      let {
        key,
        color,
        fontSize = lineFontSize,
        ...rest
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const foundData = data.find(function () {
        let {
          key: dataKey
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return key === dataKey;
      });
      if (!foundData) {
        return null;
      }
      const {
        x,
        y
      } = foundData;
      return {
        ...rest,
        key,
        color: (0, colors_1.parseColor)(color, lineColor),
        fontSize,
        radius: lineWeight,
        x,
        y,
        lineId: id
      };
    }).filter(a => a);
  }).flat(),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataSeriesOptionsIdsString, lineDataIdsString]);
  // Legend
  const legendCategories = (0, react_1.useMemo)(() => lineData.map((line, i) => {
    const ln = data[data.map(d => d.id).indexOf(line.id)];
    return {
      id: line.id,
      color: (0, colors_1.parseColor)(line.color, colors_1.DEFAULT_COLORS[i]),
      label: (line === null || line === void 0 ? void 0 : line.labelText) ?? ln.name,
      highlighted: selectedLines.includes(line.id)
    };
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString, lineDataIdsString, selectedLinesIdsString]);
  // Tooltip
  const {
    tooltip,
    mouseOver: onMouseOverTooltip,
    moveTooltip
  } = (0, useTooltips_1.default)({
    lineData,
    annotationData,
    data,
    xScale,
    yScale,
    selectedLines
  });
  const {
    sources: footerSources,
    summary: footerSummary
  } = optsFooter.show ? (0, Sources_1.useSources)({
    data,
    chartSources: optsFooter.sources
  }) : {
    sources: [],
    summary: ''
  };
  const {
    footnotes
  } = optsFooter.show ? (0, Footnotes_1.useFootnotes)({
    data,
    chartFootnotes: optsFooter.footnotes,
    showMetricFootnotes: optsFooter.showMetricFootnotes
  }) : {
    footnotes: []
  };
  const setTooltipToLineEnd = (0, react_1.useCallback)((event, i) => {
    if (!selectedLines || !selectedLines.length || selectedLines.includes(lineData[i].id)) {
      const lineDataData = lineData.map(_ref17 => {
        let {
          data,
          customDomain
        } = _ref17;
        return data.filter(_ref18 => {
          let {
            x
          } = _ref18;
          if ((0, date_1.isDateType)(xType)) {
            var _customDomain$, _customDomain$$getTim, _customDomain$2, _customDomain$2$getTi;
            const time = x.getTime();
            return time >= (customDomain === null || customDomain === void 0 ? void 0 : (_customDomain$ = customDomain[0]) === null || _customDomain$ === void 0 ? void 0 : (_customDomain$$getTim = _customDomain$.getTime) === null || _customDomain$$getTim === void 0 ? void 0 : _customDomain$$getTim.call(_customDomain$)) && time <= (customDomain === null || customDomain === void 0 ? void 0 : (_customDomain$2 = customDomain[1]) === null || _customDomain$2 === void 0 ? void 0 : (_customDomain$2$getTi = _customDomain$2.getTime) === null || _customDomain$2$getTi === void 0 ? void 0 : _customDomain$2$getTi.call(_customDomain$2));
          }
          return x >= customDomain[0] && x <= customDomain[1];
        });
      });
      if (!lineData[i]) {
        return;
      }
      const validPoints = lineDataData[i].filter(_ref19 => {
        let {
          y
        } = _ref19;
        return Number.isFinite(y);
      });
      const lastPoint = validPoints[validPoints.length - 1];
      let point = {
        datum: lastPoint,
        direction: 'above',
        line: data.find(_ref20 => {
          let {
            id
          } = _ref20;
          return id === lineData[i].id;
        }) || [],
        lineNum: i
      };
      point = (0, helpers_1.findAnnotationForPoint)(point, annotationData);
      moveTooltip(point, xScale, yScale);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataSeriesOptionsIdsString, dataIdsString, lineDataIdsString, selectedLinesIdsString, xScaleRange, xScaleTicks, yScaleRange, yScaleTicks]);
  const shouldLegend = chartWidth => showLegend || showLegend === undefined && chartWidth <= constants_2.AUTO_LEGEND_BREAKPOINT;
  const legend = react_1.default.createElement("div", {
    style: {
      margin: `${optsXAxis.fontSize}px 0`
    },
    onMouseOut: () => {
      moveTooltip();
    },
    onBlur: () => {
      moveTooltip();
    },
    className: styles_module_css_1.default['chart-header']
  }, react_1.default.createElement("div", {
    style: {
      color: constants_1.AXIS_TEXT_COLOR,
      fontSize: optsLegend.fontSize,
      letterSpacing: '2px',
      lineHeight: 1,
      marginBottom: '0.5em',
      display: optsLegend.showTitle ? 'inline' : 'none'
    }
  }, "SELECT A LINE"), react_1.default.createElement(Legend_1.default, {
    ...{
      categories: legendCategories,
      fontSize: optsLegend.fontSize,
      onMouseOver: (event, i) => {
        if (lastTouchPoint === undefined) {
          setTooltipToLineEnd(event, i);
        }
        setHoveredLabel(lineData[i].id);
      },
      onMouseOut: () => {
        setHoveredLabel(undefined);
      },
      onClick: setLine,
      style: {
        cursor: 'pointer'
      }
    }
  }));
  const slotAboveChart = _ref21 => {
    let {
      chartWidth
    } = _ref21;
    if (optsLegend.location === 'top' && shouldLegend(chartWidth)) {
      return legend;
    }
    return react_1.default.createElement("div", {
      style: {
        height: constants_2.DEFAULT_LEGEND_PADDING
      }
    });
  };
  const slotBelowChart = _ref22 => {
    let {
      chartWidth
    } = _ref22;
    if (optsLegend.location === 'bottom' && shouldLegend(chartWidth)) {
      return legend;
    }
    return react_1.default.createElement("div", {
      style: {
        height: constants_2.DEFAULT_LEGEND_PADDING
      }
    });
  };
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: styles_module_css_1.default['line-chart'],
    title: optsTitle.text,
    subtitle: optsSubtitle.text,
    titleFontSize: optsTitle.fontSize,
    subtitleFontSize: optsSubtitle.fontSize,
    footerSources: footerSources,
    footerSummary: footerSummary,
    footnotes: footnotes,
    showFooter: optsFooter.show,
    width: lineChartWidth,
    height: lineChartHeight,
    fontSize: optsFooter.fontSize,
    slotAboveChart: slotAboveChart,
    slotBelowChart: slotBelowChart,
    onMouseLeave: () => {
      moveTooltip();
    }
  }, _ref23 => {
    let {
      chartWidth,
      chartHeight
    } = _ref23;
    return react_1.default.createElement(innerContent_1.default, {
      annotationData: annotationData,
      chartHeight: chartHeight,
      chartWidth: chartWidth,
      data: data,
      dataSeriesOptions: dataSeriesOptions,
      fillToOrigin: fillToOrigin,
      hoveredLabel: hoveredLabel,
      isSpark: isSpark,
      lastTouchPoint: lastTouchPoint,
      lineData: lineData,
      moveTooltip: moveTooltip,
      onClickLine: onClickLine,
      onMouseOutLine: onMouseOutLine,
      onMouseOverLine: onMouseOverLine,
      onMouseOverTooltip: onMouseOverTooltip,
      optsGridLine: optsGridLine,
      optsLabel: optsLabel,
      optsTooltip: optsTooltip,
      optsXAxis: optsXAxis,
      optsYAxis: optsYAxis,
      refittedXdomain: refittedXdomain,
      scrubStartPoint: scrubStartPoint,
      selectedLines: selectedLines,
      setHoveredLabel: setHoveredLabel,
      setlastTouchPoint: setlastTouchPoint,
      setLine: setLine,
      setScrubStartPoint: setScrubStartPoint,
      setTooltipToLineEnd: setTooltipToLineEnd,
      tooltip: tooltip,
      xScale: xScale,
      xTicks: xTicks,
      xType: xType,
      yScale: yScale,
      yTicks: yTicks,
      yType: yType
    });
  });
};
LineChart.propTypes = {
  /** Layout */
  ...ChartWrapper_1.chartWrapperPropTypes,
  /**
   * Data for the chart.
   * @param datasets Data entries.
   * Each entry contains required params id, name, x_type, y_type and a data array
   * with key/value pairs.
   * Optional params of footnote, sources array and meta array
   * @param sources Data sources in the standard format. (see chartSources for structure)
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * Defines which group and category each data belongs to. Allows override of name and color.
   * @param id metric id
   * @param color {string} color of dot 1, overrides dotOptions
   * @param lineWeight {number} weight of line
   * @param lineStyle {string} style of line, 'solid', 'dot', or 'dash'
   * @param labelText {string} label text override
   * @param tooltipTitle {string} tooltip title override
   * @param annotations {object[]} annotation objects for data series
   * @param annotations[].color {string} color of annotation text
   * @param annotations[].fontSize {number} fontSize of annotation text
   * @param annotations[].key {string} key of annotation, matches data key value in data raay
   * @param annotations[].position {string} where should the annotation be show relative to line, 'above' or 'below'
   * @param annotations[].showTitleOnChart {bool} should annotation be shown on chart
   * @param annotations[].text {string} text of annotation
   * @param annotations[].title {string} title of annotation
   */
  dataSeriesOptions: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    color: prop_types_1.string,
    endMarker: prop_types_1.bool,
    id: prop_types_1.string.isRequired,
    labelText: prop_types_1.string,
    lineStyle: (0, prop_types_1.oneOf)(['solid', 'dot', 'dash']),
    lineWeight: prop_types_1.number,
    markerColor: (0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.arrayOf)(prop_types_1.string)]),
    markerWeight: prop_types_1.number,
    tooltipTitle: prop_types_1.string,
    annotations: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      color: prop_types_1.string,
      fontSize: prop_types_1.number,
      key: prop_types_1.string.isRequired,
      position: (0, prop_types_1.oneOf)(['above', 'below']),
      showTitleOnChart: prop_types_1.bool,
      text: prop_types_1.string,
      title: prop_types_1.string
    }))
  })),
  /**
   * Configuration options for footer
   * @param fontSize {number} font size override of footer text
   * @param footnotes {object[]} footnotes to add to those found in the data
   * @param show {bool} is footer shown
   * @param showMetricFootnotes {bool} are footnotes from data series shown
   * @param sources {object[]} sources to add to those found in the data   *
   */
  footerOptions: (0, prop_types_1.shape)({
    fontSize: prop_types_1.number,
    footnotes: ChartWrapper_1.chartWrapperPropTypes.footnotes,
    show: ChartWrapper_1.chartWrapperPropTypes.showFooter,
    showMetricFootnotes: prop_types_1.bool,
    sources: ChartWrapper_1.chartWrapperPropTypes.footerSources
  }),
  /** Fill under/above line to origin */
  fillToOrigin: prop_types_1.bool,
  /** Gridline Options
   * @param color {string} color of the gridlines
   * @param scrubberColor {string} color of the scrubbers
   * @param showVerticalLines {bool} should vertical lines be shown
   * @param showHorizontalLines {bool} should horizontal lines be shown
   * @param showVerticalScrubber {bool} should vertical scrubber be shown
   * @param showHorizontalScrubber {bool} should horizontal scrubber be shown
   * @param style {string} style of gridlines, 'solid', 'dot', or 'dash'
   */
  gridLineOptions: (0, prop_types_1.shape)({
    color: prop_types_1.string,
    scrubberColor: prop_types_1.string,
    showVerticalLines: prop_types_1.bool,
    showHorizontalLines: prop_types_1.bool,
    showVerticalScrubber: prop_types_1.bool,
    showHorizontalScrubber: prop_types_1.bool,
    style: (0, prop_types_1.oneOf)(['solid', 'dot', 'dash'])
  }),
  /** height of the chart. Set this to 'auto' to fill container,
   * otherwise set the height in px. */
  height: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
  /** Determine if chart should render as spark */
  isSpark: prop_types_1.bool,
  /**
   * Configuration options for labels
   * @param show {bool} should labels be shown;
   * undefined sets them automatically based on width.
   * @param width {number} maximum width of labels
   * @param fontSize {number} font size of labels
   */
  labelOptions: (0, prop_types_1.shape)({
    fontSize: prop_types_1.number,
    show: prop_types_1.bool,
    width: prop_types_1.number
  }),
  /**
   * @param showTitle {bool} Should the select line title be shown
   * @param location {string} Should the legend be at the top or bottom
   * @param show {bool} Should the legend be shown
   * @param fontSize {number} font size of legend text
   */
  legendOptions: (0, prop_types_1.shape)({
    showTitle: prop_types_1.bool,
    location: prop_types_1.string,
    show: prop_types_1.bool,
    fontSize: prop_types_1.number
  }),
  /** On line mouse over event (event, dataIndex, data { key, formatted, value }) */
  onMouseOver: prop_types_1.func,
  /** On line mouse out event (event, dataIndex, data ) */
  onMouseOut: prop_types_1.func,
  /** On line click event (event, data { key, formatted, value }) */
  onClick: prop_types_1.func,
  /** Default selected line id */
  selectedLineId: prop_types_1.string,
  /**
   * Chart wrapper subtitle options
   * @param fontSize {number} font size of title
   * @param text {string} text to be used as a subtitle
   */
  subtitleOptions: (0, prop_types_1.shape)({
    fontSize: prop_types_1.number,
    text: prop_types_1.string
  }),
  /**
   * Chart wrapper title options
   * @param fontSize {number} font size of title
   * @param text {string} text to be used as a title
   */
  titleOptions: (0, prop_types_1.shape)({
    fontSize: prop_types_1.number,
    text: prop_types_1.string
  }),
  /**
   * Configuration options for tooltips
   * @param color {string} color of tooltip text
   * @param decimals {bool} decimals to show on tooltip
   * @param units {string} text to display after value
   * @param show {bool} are tooltips visible
   * @param showSubtitle {bool} are tooltip subtitles shwon
   */
  tooltipOptions: (0, prop_types_1.shape)({
    color: prop_types_1.string,
    decimals: prop_types_1.number,
    units: prop_types_1.string,
    show: prop_types_1.bool,
    showSubtitle: prop_types_1.bool
  }),
  /** length of transitions in ms */
  transitionDuration: prop_types_1.number,
  /** width of chart */
  width: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
  /**
   * Configuration options for the xAxis
   * @param displayRangeMin {number,string} domain minimum to be used for the axis
   * @param displayRangeMax {number,string} domain maximum to be used for the axis
   * @param displayTicks {string[]} what positions to display axis - 'top','bottom'
   * @param textColor {string} color of text color
   * @param ticks {number[], string[]} override calculated ticks
   * @param type {string} data type - 'linear','unformatted','percent','dollars','years','months','quarters','days','daily','weeks','weekly'
   * @param fontSize font size for xAxis labels
   */
  xAxisOptions: (0, prop_types_1.shape)({
    displayRangeMin: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayRangeMax: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayTicks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(lodash_1.default.values(Axis_1.AXIS_POSITIONS))),
    labelFormatter: prop_types_1.func,
    textColor: prop_types_1.string,
    ticks: (0, prop_types_1.arrayOf)(prop_types_1.number),
    type: (0, prop_types_1.oneOf)(constants_1.AXIS_TYPES),
    fontSize: prop_types_1.number
  }),
  /**
   * Configuration options for the yAxis
   * @param displayRangeMin {number,string} domain minimum to be used for the axis
   * @param displayRangeMax {number,string} domain maximum to be used for the axis
   * @param displayTicks {string[]} what positions to display axis - 'top','bottom'
   * @param textColor {string} color of text color
   * @param ticks {number[], string[]} override calculated ticks
   * @param type {string} data type - 'linear','unformatted','percent','dollars','years','months','quarters','days','daily','weeks','weekly'
   * @param fontSize font size for yAxis labels
   */
  yAxisOptions: (0, prop_types_1.shape)({
    displayRangeMin: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayRangeMax: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayTicks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(lodash_1.default.values(Axis_1.AXIS_POSITIONS))),
    labelFormatter: prop_types_1.func,
    textColor: prop_types_1.string,
    ticks: (0, prop_types_1.arrayOf)(prop_types_1.number),
    type: (0, prop_types_1.oneOf)(constants_1.AXIS_TYPES),
    fontSize: prop_types_1.number
  })
};
exports.default = LineChart;